import { ILoginInfo } from "../models/ILoginInfo";
import { IRoles, IUserRoles } from "../models/IUserRoles";
import { IUserVerificationStatus } from "../models/IUserVerificationStatus";
import { configWithUserFileToken, configWithUserToken, configWithWebToken, ensureWebToken } from "./config";

/** Uygulama (web) token'ının hazır olduğunu garanti eder — bkz. services/config.ts. */
export const getTokenForWeb = ensureWebToken;

export const loginUser = (email: string, password: string, deviceId: string) => {
  return configWithWebToken.post<ILoginInfo>("Auth/UserLogin", {
    email,
    password,
    deviceId,
  });
};

export const googleLogin = (idToken: string, deviceId: string) => {
  return configWithWebToken.post<ILoginInfo>("Auth/GoogleLogin", {
    idToken,
    deviceId,
    dateOfBirth: "",
    phoneNumber: "",
  });
};

/**
 * verificationId her zaman gönderilir: numara birden çok hesapta duruyorsa API onsuz
 * kodu hiçbir kayda göndermez ("Kullanıcı sistemde mevcut değil", code "7").
 * Kayıt akışında kayıt yanıtının `verificaitonId`'si, profilde `verification.id`.
 */
export const resendPhoneOtp = (phoneNumber: string, verificationId: string) => {
  return configWithWebToken.post<{ code: string; desc: string; verificationId: string }>(
    `Auth/ResendPhoneOtp?phoneNumber=${encodeURIComponent(phoneNumber)}&verificationId=${encodeURIComponent(verificationId)}`
  );
};

export const verifyPhoneOtp = (verificationId: string, otp: string, source: string) => {
  return configWithWebToken.put<{
    token: string;
    expiration: string;
    secretKey: string;
    userId: string;
    refreshToken?: string;
    refreshTokenExpiration?: string;
  }>(
    `Auth/RegisterPhoneVerification/${verificationId}/${otp}/${encodeURIComponent(source)}`
  );
};

export const verifyEmailOtp = (verificationId: string, emailOtpCode: string) => {
  return configWithWebToken.put(
    `Auth/RegisterEmailVerification/${verificationId}/${emailOtpCode}`
  );
};

export const forgetPassword = (emailAddress: string) => {
  return configWithWebToken.put("Auth/ForgetPassword", { emailAddress });
};

export const resetPassword = (newPassword: string, resetPasswordToken: string) => {
  return configWithWebToken.post("Auth/ResetPassword", { newPassword, resetPasswordToken });
};

export const resendEmailOtp = (email: string) => {
  return configWithWebToken.post<{ code: string; desc: string; verificationId: string }>(
    `Auth/ResendEmailOtp?email=${encodeURIComponent(email)}`
  );
};

export const getUserVerificationStatus = (userId: string) => {
  return configWithUserToken.get<IUserVerificationStatus>(
    "Auth/IsDoBMailPhoneByUserIdAsync",
    { params: { userId } }
  );
};

export const getUserRoles=(userId:string)=>{
  return configWithUserFileToken.get<IUserRoles>("UserRole/RolesByUserId/"+userId);
}
export const getRoles=()=>{
  return configWithUserFileToken.get<IRoles>("Role/roleList")
}

export interface ICustomerDetailsByToken {
  id: string;
  customerName: string;
  customerSurName: string;
  customerUserName: string;
  customerEmail: string;
  customerTelNo: string;
  customerBirthDate: string;
  customerIsEnabled: boolean;
}

export const getCustomerDetailsByToken = () => {
  return configWithUserToken.get<ICustomerDetailsByToken>("Auth/CustomerDetailsByToken");
};

